// https://github.com/aws-amplify/amplify-cli/issues/2420

export const getInboundShipment = /* GraphQL */ `
  query GetInboundShipment($id: ID!) {
    getInboundShipment(id: $id) {
      id
      owner
      groups
      active
      status
      state
      gateCheckInId
      poNumber
      lotNumber
      lotNumberOverride
      shipFrom
      carrierType
      carrierEquipmentTypeId
      carrierName
      lotType
      railCarNumber
      containerDrop
      containerNumber
      totalUOM
      skipInvoice
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      stepName
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      signedBy
      advisedBy
      createDateTime
      scheduledDateTime
      timeslotId
      timeslot {
        id
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        outboundId
        accountName
        accountId
        eventTypeId
        eventType {
          id
          active
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          assetType {
            id
            maxConcurrentBookings
          }
          schedule {
            workdays {
              id
              name
              startDayTime
              endDayTime
              selected
            }
            minNoticeHours
            maxDaysIntoFuture
          }
        }
      }
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      collectedDateTime
      isCollected
      stripeBillingDateTime
      daysOnDemurrageClock
      assignedTo
      workflowType
      unloadedBy
      reviewedBy
      secondaryReview
      verificationRequired
      stockImport
      returnShipment
      sit
      returnOutboundShipmentId
      returnReason
      hasException
      unsafeShipment
      unsafeShipmentNote
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      sealNumbers
      seals {
        items {
          id
          active
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          owner
          brokenAt
          brokenBy
          validated
          description
          updatedAt
        }
      }
      areaId
      area {
        id
        active
        reloadYardId
        name
        prefix
        areaType
        sortKey
        zones {
          items {
            id
            active
            accountId
            areaId
            name
            prefix
            sortKey
          }
          nextToken
        }
      }
      zoneId
      zone {
        id
        active
        reloadYardId
        name
        prefix
        accountId
        areaId
        sortKey
      }
      photos {
        items {
          id
          bucket
          region
          key
          name
        }
      }
      attachments {
        bucket
        region
        key
        type
      }
      receiptFile {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptNumber
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        groups # required by the scheduler -> Timeslot groupsField auth
        reloadYardId # required by the scheduler -> Timeslot GSI partition key
        lotNumberPrefix
        fifoLotNumber
        carlotLotNumber
        businessName
        displayName
        accountType
        defaultBillToAccountId
        defaultWeightUOM
        inboundEventTypeId # scheduler: resolve default event type on advice edit
        email
        phone
        # fax
        # website
        address {
          name
          street
          city
          state
          zipCode
          country
        }
        inboundCustomFields {
          id
          name
          type
          display
          required
        }
        inboundInstructions
        podEmail
        podPhotos
        podAttachments
        podSubject
        trackInboundSeals
        verifyOutboundRailCar
        requireDefaultZone
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
        checklists {
          items {
            id
            active
            name
            processName
            checklistItems {
              name
              description
              stepName
              isRequired
              isCompleted
              completedBy
              completedAt
            }
          }
        }
        receiptTemplate {
          bucket
          region
          key
          type
          # createdBy
          # createdAt
        }
      }
      billToAccount {
        businessName
        displayName
      }
      reloadYardId
      inventories {
        items {
          id
          owner
          groups
          containerNumber
          active
          status
          lotNumber
          poNumber
          railCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityPrecount
          quantityReceived
          quantityOnHand
          quantityPhysical
          quantityCommitted
          quantityMismatch
          inventoryUOM
          # returnShipmentLineItemId
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          productName
          braRawProductName
          productCode
          productId
          product {
            id
            altNames
            category
            defaultUOM
            defaultWeightUOM
            unit
            pcs
            mbf
            lf
            sf
            msf
            sqm
            gal
            l
            lbs
            tn
            cwt
            kg
            mt
            ft
            m
            pcsHeight
            pcsWidth
            pcsLength
            # width
            # length
            # height
            lowInventoryThreshold
            totalInventoryQuantity
            totalQuantityOnHand
            totalQuantityCommitted
            lowInventoryAlert
            customFields
          }
          aggregateInventoryId
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          auditId
          # notes {
          #   type
          #   date
          #   by
          #   text
          #   public
          # }
          history {
            type
            date
            by
            text
          }
          reloadYardCommodityId
          reloadYardCommodity {
            commodity {
              locationLoadType
              name
            }
          }
          inventoryItems {
            items {
              id
              quantityOnHand
              quantityCommitted
              hasException
              isDamaged
              originOfDamage
              status
              depletedAt
              inboundShipmentId
              inventoryId
              areaId
              zoneId
              aisleId
              locationId
              location {
                id
                active
                areaId
                zoneId
                productName
                aisleId
                productId
                reloadYardId
                type
                capacityUsed
                capacityAllocated
                sortKey
                accountName
                aisle {
                  id
                  owner
                  groups
                  active
                  reloadYardId
                  name
                  type
                  areaId
                  zoneId
                  sortKey
                  totalLocations
                }
                locationLoad {
                  other {
                    selected
                    capacity
                  }
                  pallet {
                    selected
                    capacity
                  }
                  box {
                    selected
                    capacity
                  }
                  container {
                    selected
                    capacity
                  }
                  superSack {
                    selected
                    capacity
                  }
                  dryBulk {
                    selected
                    capacity
                  }
                  liquidBulk {
                    selected
                    capacity
                  }
                }
              }
              outboundShipmentId
              locationFullName
            }
          }
          shipmentLineItems {
            items {
              id
              status
              inventoryId
              outboundShipmentId
              outboundShipment {
                pickupNumber
                departureDateTime
              }
              inventoryItems {
                items {
                  id
                  inventoryItemId
                  status
                }
                nextToken
              }
            }
          }
          customFields
          sortKey
          # createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      invoice {
        invoiceNumber
        inboundShipmentId
      }
      invoicedServices {
        items {
          itemTotal
        }
        nextToken
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        commodityId
        units
        sortKey
        commodity {
          name
          locationLoadType
          validUom
          inventoryFields
        }
      }
      checklistId
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
      }
      manualCharges {
        items {
          id
          quantity
          chargeRuleId
          chargeRule {
            id
            serviceId
            service {
              id
              name
              taxRate {
                taxCode
                name
                taxRate
              }
            }
            billingUOM
            minCharge
            maxCharge
            execution
          }
          sortKey
          invoiceServiceId
        }
        nextToken
      }
      trackCar {
        id
        active
        areaId
        zoneId
        aisleId
        trackId
        locationFullName
        sortKey
        location {
          id
          name
          type
          areaId
          area {
            id
            name
            prefix
            areaType
          }
          zoneId
          zone {
            id
            name
            prefix
            accountId
            zoneType
          }
          aisleId
          aisle {
            id
            name
            type
          }
        }
      }
      # createdAt
      updatedAt
    }
  }
`;

export const getInboundShipmentForInvoice = /* GraphQL */ `
  query GetInboundShipment($id: ID!) {
    getInboundShipment(id: $id) {
      id
      status
      state
      poNumber
      placedDateTime
      releaseDateTime
      collectedDateTime
      isCollected
      carrierType
      carrierEquipmentTypeId
      containerDrop
      containerNumber
      railCarNumber
      lotNumber
      totalUOM
      skipInvoice
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      areaId
      area {
        areaType
      }
      zoneId
      history {
        type
        date
        by
        text
      }
      accountId
      billToAccountId
      reloadYardCommodityId

      # for rule-based billing per area / zone / loadType
      inventories {
        items {
          id
          receivedAt
          containerNumber
          status
          poNumber
          railCarNumber
          quantityReceived
          inventoryUOM
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          weight
          weightUOM
          areaId
          zoneId
          productId
          product {
            id
            defaultUOM
            defaultWeightUOM
            unit
            pcs
            mbf
            lf
            sf
            msf
            sqm
            gal
            l
            lbs
            tn
            cwt
            kg
            mt
            ft
            m
            pcsHeight
            pcsWidth
            pcsLength
          }
          aggregateInventoryId
          reloadYardCommodityId
        }
        nextToken
      }
      invoiceId
      invoice {
        invoiceNumber
      }
      invoicedServices {
        items {
          itemTotal
        }
        nextToken
      }
      manualCharges {
        items {
          id
          quantity
          chargeRule {
            id
            event
            frequency
            serviceId
            service {
              id
              name
              unit
              pcs
              car
              tl
              mbf
              lf
              sf
              msf
              sqm
              gal
              l
              lbs
              tn
              cwt
              kg
              mt
              ft
              m
              taxRate {
                taxCode
                name
                taxRate
              }
            }
            billingUOM
            feeAccrual
            freeDays
            freeDaysPolicy
            graduatedRates {
              days
              rate
            }
            minCharge
            maxCharge
            execution
          }
        }
        nextToken
      }
    }
  }
`;

export const getInboundShipmentForUpdate = /* GraphQL */ `
  query GetInboundShipment($id: ID!) {
    getInboundShipment(id: $id) {
      id
      active
      status
      state
      railCarNumber
      accountName
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      releaseDateTime
      invoiceId
    }
  }
`;

export const getInboundShipmentForValidate = /* GraphQL */ `
  query GetInboundShipment($id: ID!) {
    getInboundShipment(id: $id) {
      id
      invoiceId
    }
  }
`;

// Lean fetch of just the embedded history array, used to read-modify-write
// history from list/bulk contexts (where the list query omits `history`).
// Bulk advance reads this before writing: the history it must append to rather
// than overwrite, and the commitment fields the release guard needs (the SIT
// list itself carries neither).
export const getInboundShipmentHistory = /* GraphQL */ `
  query GetInboundShipment($id: ID!) {
    getInboundShipment(id: $id) {
      id
      sit
      status
      state
      areaId
      railCarNumber
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      history {
        type
        date
        by
        text
      }
      inventories {
        items {
          id
          quantityCommitted
          # Placement of the stock, for the release commitment guard: an
          # inventory unloaded into the yard is not reached by the release.
          inventoryItems {
            items {
              id
              status
              areaId
            }
          }
          shipmentLineItems {
            items {
              id
              status
              outboundShipmentId
              outboundShipment {
                pickupNumber
              }
            }
          }
        }
      }
    }
  }
`;

export const inboundShipmentByReloadYardByAccount = /* GraphQL */ `
  query InboundShipmentByReloadYardByAccount(
    $reloadYardId: ID
    $accountId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByReloadYardByAccount(
      reloadYardId: $reloadYardId
      accountId: $accountId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

//###############################################
// crewApp/inboundList
//###############################################
export const inboundShipmentByStateByRailcarReduced = /* GraphQL */ `
  query InboundShipmentByStateByRailcar(
    $reloadYardId: ID
    $stateRailCarNumber: ModelInboundShipmentInboundShipmentByStateByRailcarCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByStateByRailcar(
      reloadYardId: $reloadYardId
      stateRailCarNumber: $stateRailCarNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        state
        lotNumber
        poNumber
        lotNumberOverride
        railCarNumber
        accountName
        reloadYardId
        carrierType
        releaseDateTime
        placedDateTime
        notifyDateTime
        scheduledDateTime
        createDateTime
        accountId
        assignedTo
        areaId
        zoneId
        verificationRequired
        unloadedBy
        sit
        account {
          businessName
          displayName
          accountType
        }
      }
    }
  }
`;

export const getInboundShipmentMobile = /* GraphQL */ `
  query GetInboundShipment($id: ID!) {
    getInboundShipment(id: $id) {
      id
      status
      state
      poNumber
      lotNumber
      lotNumberOverride
      shipFrom
      carrierType
      carrierName
      lotType
      railCarNumber
      stockImport
      verificationRequired
      totalUOM
      tareWeight
      ladenWeight
      weightUnits
      netWeight
      scaleWeightUnits
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      collectedDateTime
      workflowType
      unloadedBy
      reviewedBy
      secondaryReview
      stripeBillingDateTime
      daysOnDemurrageClock
      reloadYardCommodityId
      hasException
      unsafeShipment
      unsafeShipmentNote
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      sealNumbers
      containerNumber
      containerDrop
      seals {
        items {
          id
          active
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          createdAt
          createdBy
          brokenAt
          brokenBy
          validated
          owner
          isScanned
          description
          updatedAt
        }
      }
      stepName
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      areaId
      area {
        id
        name
        color
        prefix
        areaType
      }
      zoneId
      zone {
        id
        name
        prefix
        color
        accountId
        areaId
      }
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      accountName
      accountId
      billToAccountId
      account {
        id
        lotNumberPrefix
        businessName
        displayName
        accountType
        inboundCustomFields {
          id
          name
          type
          display
        }
        inboundInstructions
        inboundPhotos
        requireDefaultZone
        inventoryPrimaryField
        inventoryCustomFields {
          id
          name
          type
          display
        }
        inventoryPhotos
        trackInboundSeals
        verifyInboundRailCar
        verifyOutboundRailCar
      }
      reloadYardId
      inventories {
        items {
          id
          status
          accountId
          accountName
          lotNumber
          poNumber
          areaId
          zoneId
          railCarNumber
          receivedAt
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          quantityAdvised
          quantityPrecount
          inventoryUOM
          history {
            type
            date
            by
            text
          }
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          sortKey
          turnDays
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          inventoryItems {
            items {
              id
              status
              quantityOnHand
              isDamaged
              locationFullName
              areaId
              zoneId
              aisleId
              locationId
              inventoryId
              location {
                id
                active
                owner
                groups
                reloadYardId
                name
                type
                areaId
                zoneId
                aisleId
                bay
                level
                position
                productId
                productName
                accountName
                sortKey
                capacityUsed
                capacityAllocated
                bulkCapacity
                bulkUnits
                locationLoad {
                  other {
                    selected
                    capacity
                  }
                  pallet {
                    selected
                    capacity
                  }
                  box {
                    selected
                    capacity
                  }
                  container {
                    selected
                    capacity
                  }
                  superSack {
                    selected
                    capacity
                  }
                  dryBulk {
                    selected
                    capacity
                  }
                  liquidBulk {
                    selected
                    capacity
                  }
                }
              }
            }
          }
          notes {
            type
            date
            by
            text
            public
          }
          history {
            type
            date
            by
            text
          }
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityOnHand
          quantityPhysical
          quantityCommitted
          quantityMismatch
          inventoryUOM
          lotType
          productName
          productCode
          productId
        }
      }
      trackCar {
        id
        active
        areaId
        zoneId
        aisleId
        trackId
        locationFullName
        sortKey
        location {
          id
          name
          type
          areaId
          area {
            id
            name
            prefix
            areaType
          }
          zoneId
          zone {
            id
            name
            prefix
            accountId
            zoneType
          }
          aisleId
          aisle {
            id
            name
            type
          }
        }
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        showCounter
        units
        sortKey
        commodity {
          id
          name
          defaultUnits
          enableCounter
          locationLoadType
        }
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
      }
    }
  }
`;

//###############################################
// managerApp/inboundList
//###############################################
export const inboundShipmentByReloadYardByStatusByDates = /* GraphQL */ `
  query InboundShipmentByReloadYardByStatusByDates(
    $reloadYardId: ID
    $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: ModelInboundShipmentInboundShipmentByReloadYardByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByReloadYardByStatusByDates(
      reloadYardId: $reloadYardId
      statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        status
        state
        poNumber
        lotNumber
        shipFrom
        carrierType
        carrierName
        lotType
        railCarNumber
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        netWeight
        weightUnits
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        isCollected
        sit
        daysOnDemurrageClock
        assignedTo
        verificationRequired
        returnShipment
        accountName
        accountId
        account {
          id
          businessName
          displayName
          accountType
        }
        reloadYardId
        areaId
        inventories {
          items {
            id
            quantityAdvised
            quantityReceived
            status
          }
        }
        billToAccountId
        invoiceId
        invoice {
          invoiceNumber
        }
        invoicedServices {
          items {
            itemTotal
          }
          nextToken
        }
        hasException
      }
      nextToken
    }
  }
`;

//###############################################
// crewApp/gateQueue
//###############################################
// Selection carries every member of the inbound composite sort keys
// (status, releaseDateTime, createDateTime, scheduledDateTime,
// notifyDateTime, placedDateTime, startDateTime, endDateTime) so
// ensureCompositeKeyFields can echo them on the placement update, the
// account lot-template fields so autogenLotNumber can resolve at
// placement, and history so the placement note appends instead of
// replacing.
export const inboundShipmentByStatusGateQueue = /* GraphQL */ `
  query InboundShipmentByReloadYardByStatusByDates(
    $reloadYardId: ID
    $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: ModelInboundShipmentInboundShipmentByReloadYardByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByReloadYardByStatusByDates(
      reloadYardId: $reloadYardId
      statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        status
        state
        sit
        poNumber
        containerNumber
        lotNumber
        lotNumberOverride
        lotType
        shipFrom
        carrierType
        carrierName
        railCarNumber
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        history {
          type
          date
          by
          text
        }
        accountName
        accountId
        account {
          id
          carlotLotNumber
          fifoLotNumber
          lotNumberPrefix
        }
        reloadYardId
        # Only the count is read, by canPlaceInboundShipment — an inbound with
        # no inventory has nothing for the crew to process and cannot be
        # placed. Ids only: the queue never renders the rows.
        inventories {
          items {
            id
          }
        }
      }
      nextToken
    }
  }
`;

//###############################################
// gateCheckIns: placing one shipment from the gate check-in control.
// Carries every composite sort-key member so ensureCompositeKeyFields can echo
// them, plus the account and lot fields the lot-number regeneration needs.
//###############################################
export const getInboundShipmentGatePlacement = /* GraphQL */ `
  query GetInboundShipment($id: ID!) {
    getInboundShipment(id: $id) {
      id
      active
      status
      state
      sit
      gateCheckInId
      poNumber
      containerNumber
      lotNumber
      lotNumberOverride
      lotType
      carrierType
      carrierName
      railCarNumber
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      history {
        type
        date
        by
        text
      }
      accountId
      account {
        id
        carlotLotNumber
        fifoLotNumber
        lotNumberPrefix
      }
      reloadYardId
      # Count only, for canPlaceInboundShipment — DOCKED must not place an
      # inbound with nothing to process.
      inventories {
        items {
          id
        }
      }
    }
  }
`;

//###############################################
// carrierApp/inboundList
//###############################################
export const inboundShipmentByCarrierByStatusByDates = /* GraphQL */ `
  query InboundShipmentByCarrierByStatusByDates(
    $carrierId: ID
    $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: ModelInboundShipmentInboundShipmentByCarrierByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByCarrierByStatusByDates(
      carrierId: $carrierId
      statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        status
        state
        poNumber
        lotNumber
        shipFrom
        carrierType
        carrierName
        carrierId
        driverId
        driverName
        lotType
        railCarNumber
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        netWeight
        weightUnits
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        isCollected
        sit
        daysOnDemurrageClock
        assignedTo
        verificationRequired
        returnShipment
        accountName
        accountId
        account {
          id
          businessName
          displayName
          accountType
        }
        reloadYardId
        inventories {
          items {
            id
            quantityAdvised
            quantityReceived
            status
          }
        }
        billToAccountId
        invoiceId
        invoice {
          invoiceNumber
        }
        invoicedServices {
          items {
            itemTotal
          }
          nextToken
        }
        hasException
      }
      nextToken
    }
  }
`;

//###############################################
// managerApp/customerApp/inboundList
//###############################################
export const inboundShipmentByAccountByStatusByDates = /* GraphQL */ `
  query InboundShipmentByAccountByStatusByDates(
    $accountId: ID
    $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: ModelInboundShipmentInboundShipmentByAccountByStatusByDatesCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByAccountByStatusByDates(
      accountId: $accountId
      statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime: $statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        status
        state
        poNumber
        lotNumber
        shipFrom
        carrierType
        carrierName
        lotType
        railCarNumber
        totalUOM
        skipInvoice
        tareWeight
        ladenWeight
        netWeight
        weightUnits
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        isCollected
        sit
        daysOnDemurrageClock
        assignedTo
        verificationRequired
        returnShipment
        accountName
        accountId
        account {
          id
          businessName
          displayName
          accountType
        }
        reloadYardId
        inventories {
          items {
            id
            quantityAdvised
            quantityReceived
            status
          }
        }
        billToAccountId
        invoiceId
        invoice {
          invoiceNumber
        }
        invoicedServices {
          items {
            itemTotal
          }
          nextToken
        }
        hasException
      }
      nextToken
    }
  }
`;

export const searchInboundShipments = /* GraphQL */ `
  query SearchInboundShipments(
    $filter: SearchableInboundShipmentFilterInput
    $sort: SearchableInboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        active
        attachments {
          bucket
          key
          region
        }
        status
        state
        poNumber
        lotNumber
        shipFrom
        carrierType
        carrierName
        carrierId
        lotType
        railCarNumber
        customFields
        totalUOM
        skipInvoice
        netWeight
        weightUnits
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        isCollected
        sit
        daysOnDemurrageClock
        assignedTo
        verificationRequired
        returnShipment
        accountName
        accountId
        account {
          id
          businessName
          displayName
          lotNumberPrefix
          accountType
        }
        billToAccountId
        invoiceId
        invoice {
          invoiceNumber
        }
        invoicedServices {
          items {
            itemTotal
          }
          nextToken
        }
        inventories {
          items {
            id
            status
            productCode
            productName
            quantityAdvised
            quantityReceived
            quantityOnHand
            quantityCommitted
          }
        }
        areaId
        zoneId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          commodityId
          active
          units
        }
        hasException
        createdAt
      }
      nextToken
      total
    }
  }
`;

export const countInboundShipments = /* GraphQL */ `
  query SearchInboundShipments(
    $filter: SearchableInboundShipmentFilterInput
    $sort: SearchableInboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      total
    }
  }
`;

export const getInboundShipmentSeals = /* GraphQL */ `
  query GetInboundShipment($id: ID!) {
    getInboundShipment(id: $id) {
      sealNumbers
      carrierType
      railCarNumber
      trackCar {
        id
        trackId
        locationFullName
        location {
          id
          name
          type
          areaId
          area {
            id
            name
            prefix
            areaType
          }
          zoneId
          zone {
            id
            name
            prefix
            accountId
            zoneType
          }
          aisleId
          aisle {
            id
            name
            type
          }
        }
      }
      id
      owner
      groups
      reloadYardId
      accountId
      accountName
      account {
        id
        verifyInboundRailCar
      }
      seals {
        items {
          id
          active
          owner
          groups
          status
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          updatedAt
        }
        nextToken
      }
      history {
        type
        date
        by
        text
      }
    }
  }
`;

// duplicate po number check
export const inboundShipmentByAccountByPoNumber = /* GraphQL */ `
  query InboundShipmentByAccountByPoNumber(
    $accountId: ID
    $normalizedPoNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByAccountByPoNumber(
      accountId: $accountId
      normalizedPoNumber: $normalizedPoNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

// Track Management pulls a car with a payload that carries no history; this
// reads just what the "Time Pulled" note appends to. Kept lean on purpose:
// no nested non-null field can reject the read and cost the note.
export const getInboundShipmentTimePulled = /* GraphQL */ `
  query GetInboundShipmentTimePulled($id: ID!) {
    getInboundShipment(id: $id) {
      id
      collectedDateTime
      history {
        type
        date
        by
        text
      }
    }
  }
`;
